import React from "react";

const sections = [
  {
    title: "Booking & Payment",
    paragraphs: [
      <>
        All online bookings are subject to vehicle availability and
        confirmation by <strong>OH MY CAR RENT A CAR LLC</strong>. Payment must
        be made using the authorised payment methods available on our website.
      </>,
    ],
  },
  {
    title: "Rental Requirements",
    paragraphs: [
      "Customers must provide valid identification and driving documents, including a valid UAE or internationally recognised driving licence, passport, Emirates ID, and any other documents required under applicable UAE laws, RTA regulations, and insurance requirements.",
      "Online payment does not guarantee vehicle handover if the customer does not meet the required rental conditions.",
    ],
  },
  {
    title: "Rental Charges",
    paragraphs: [
      <>
        The customer is responsible for the agreed rental charges and any
        applicable{" "}
        <strong>
          VAT, Salik, traffic fines, parking fines, fuel charges, additional
          mileage, late-return charges, damage charges
        </strong>
        , and other amounts specified in the rental agreement.
      </>,
    ],
  },
  {
    title: "Security Deposit",
    paragraphs: [
      "Where applicable, a security deposit may be required. The deposit may be used to settle legitimate outstanding charges, including damage, fines, Salik, fuel, excess mileage, or other amounts payable under the rental agreement.",
      "Any remaining balance will be refunded in accordance with the applicable rental and payment terms.",
    ],
  },
  {
    title: "Cancellation & Refunds",
    paragraphs: [
      "Cancellation and refund conditions will be communicated at the time of booking and/or stated in the rental agreement.",
      "Approved refunds will normally be processed through the original payment method. Bank or payment-provider processing times may apply.",
    ],
  },
  {
    title: "Vehicle Use",
    paragraphs: [
      "Only authorised drivers listed in the rental agreement may drive the vehicle.",
      "The vehicle must be used responsibly and in accordance with UAE laws, RTA regulations, applicable insurance conditions, and the rental agreement.",
      <strong>
        Racing, illegal activities, sub-renting, unauthorised commercial use,
        and driving by unauthorised persons are strictly prohibited.
      </strong>,
    ],
  },
  {
    title: "Accidents, Theft & Damage",
    paragraphs: [
      "In the event of an accident, theft, or damage, the customer must immediately notify the relevant authorities where required and inform OH My Car.",
      "The customer's liability will be determined in accordance with the rental agreement, applicable insurance terms, and UAE law.",
    ],
  },
  {
    title: "Vehicle Return",
    paragraphs: [
      "The vehicle must be returned on the agreed date, time, and location, in the agreed condition, with the required fuel level and all keys, documents, and accessories.",
      "Additional charges may apply for late return, missing items, excessive cleaning, damage, or other applicable costs as stated in the rental agreement.",
    ],
  },
  {
    title: "Online Transactions",
    paragraphs: [
      "Customers must use an authorised payment method and provide accurate booking and payment information.",
      "OH My Car reserves the right to verify or decline suspicious, fraudulent, or unauthorised transactions before releasing a vehicle.",
    ],
  },
  {
    title: "Privacy",
    paragraphs: [
      "Customer information may be collected, stored, and processed for booking, payment, vehicle rental, insurance, accounting, legal, and regulatory purposes in accordance with applicable UAE laws and regulations.",
    ],
  },
  {
    title: "Governing Law",
    paragraphs: [
      <>
        These Terms and Conditions are governed by the applicable laws of the{" "}
        <strong>United Arab Emirates and the Emirate of Dubai</strong>,
        including applicable RTA requirements.
      </>,
    ],
  },
  {
    title: "Customer Agreement",
    paragraphs: [
      "By making an online booking or payment, the customer confirms that they have read, understood, and accepted these Terms and Conditions and the applicable Rental Agreement.",
    ],
  },
];

function Terms() {
  return (
    <main className="termsPage">
      <section className="termsHero">
        <p>Online Booking & Payment</p>
        <h1>Terms & Conditions</h1>
        <span>OH MY CAR RENT A CAR LLC · Dubai, United Arab Emirates</span>
      </section>

      <ol className="termsList">
        {sections.map((section, index) => (
          <li key={section.title} className="termsSection">
            <h2>
              <span>{index + 1}.</span> {section.title}
            </h2>
            {section.paragraphs.map((paragraph, paragraphIndex) => (
              <p key={paragraphIndex}>{paragraph}</p>
            ))}
          </li>
        ))}
      </ol>

      <section className="termsContact">
        <h2>OH MY CAR RENT A CAR LLC</h2>
        <p>Dubai, United Arab Emirates</p>
        <p>
          Phone: <a href="tel:+971529497677">+971 52 949 7677</a>
        </p>
        <p>
          Email: <a href="mailto:info@ohmycar.org">info@ohmycar.org</a>
        </p>
      </section>
    </main>
  );
}

export default Terms;
